"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceUUIDInitializer = exports.DeviceUUIDInitializationError = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const deviceUUID_1 = require("./deviceUUID");
const TRACKER_ERROR = 'UI information initialization error';
class DeviceUUIDInitializationError extends web_ui_framework_1.InitializerError {
    constructor(message) {
        super(TRACKER_ERROR, message);
    }
}
exports.DeviceUUIDInitializationError = DeviceUUIDInitializationError;
class DeviceUUIDInitializer extends web_ui_framework_1.Initializer {
    constructor() {
        super(...arguments);
        this.launch = async () => {
            try {
                return await (0, deviceUUID_1.getDeviceUUID)();
            }
            catch (e) {
                throw new DeviceUUIDInitializationError(e);
            }
        };
    }
}
exports.DeviceUUIDInitializer = DeviceUUIDInitializer;
//# sourceMappingURL=uiInformation.initializer.js.map